import { DailyTask, Milestone } from "../../types/goals";

interface TodayTaskProps {
    todayTask: DailyTask;
    milestones: Milestone[];
    onCheckbox: () => void;
}
const TodayTask = ({ todayTask, milestones, onCheckbox }: TodayTaskProps) => {
    
    const taskMilestone = milestones.find(m => m._id === todayTask.milestoneId);

    return (
        <div>
            <h3 className="text-lg font-medium mb-3 text-gray-900 dark:text-white">Tarea de Hoy</h3>
            <div className="bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                <div className="flex items-start space-x-3">
                    <input
                        type="checkbox"
                        checked={todayTask.isCompleted}
                        onChange={onCheckbox}
                        className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded"
                    />
                    <div>
                        <p className="font-medium text-gray-900 dark:text-white">
                            {todayTask.title}
                        </p>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                            {todayTask.description}
                        </p>
                        <div className="mt-2 flex items-center space-x-2">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                {taskMilestone?.title}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TodayTask;